import React from 'react';
import styled from 'styled-components';
import i18n from '../../i18n';

const Select = styled.select`
  height: 42px;
  padding: 0 12px;
  border-radius: 12px;
  background: var(--card);
  color: inherit;
  border: 1px solid var(--bdr);
  box-shadow: var(--shadow);
`;

export default function LangSwitcher() {
  const [val, setVal] = React.useState(i18n.language || 'ru');

  const onChange = (e) => {
    const lng = e.target.value; // 'ru' | 'en' | 'zh'
    setVal(lng);
    i18n.changeLanguage(lng);
  };

  React.useEffect(() => {
    const h = (lng) => setVal(lng);
    i18n.on('languageChanged', h);
    return () => i18n.off('languageChanged', h);
  }, []);

  return (
    <Select value={val} onChange={onChange} aria-label="Language">
      <option value="en">ENG</option>
      <option value="ru">RU</option>
      <option value="zh">中文</option>
    </Select>
  );
}
